// "single" is for accessing a single resource that does not rely
// on an id. functions going into the constructor should just ignore
// the id
export abstract class DataFetcher<T> {
    protected cacheCollection: { [key: string]: T | Promise<T> } = {};

    constructor(
        protected fetchingApi: (id: string) => Promise<T>,
        protected deleteApi: (id: string) => Promise<void>
    ) {}

    get(id = 'single'): T {
        const details = this.acquire(id);
        return details instanceof Promise ? undefined : details;
    }

    fetch(id = 'single'): Promise<T> {
        const details = this.acquire(id);
        return details instanceof Promise ? details : Promise.resolve(details);
    }

    refetch(id = 'single'): Promise<T> {
        if (!id) {
            return;
        }
        return this.fetchingApi(id).then((item) => {
            this.cacheCollection[id] = item;
            return this.cacheCollection[id];
        });
    }

    private acquire(id = 'single'): T | Promise<T> {
        if (!id) {
            return;
        }
        if (!this.cacheCollection[id]) {
            this.cacheCollection[id] = this.fetchingApi(id).then((item) => {
                this.cacheCollection[id] = item;
                return this.cacheCollection[id];
            });
        }
        return this.cacheCollection[id];
    }
}

export class ListDataFetcher<T> extends DataFetcher<T> {
    async delete(id: string) {
        await this.deleteApi(id);
        await this.refetch();
    }
}
